<template>
  <div :class="{contentWrap:true}">
    <div class="container">
      <van-nav-bar
        :title="title"
        left-arrow
        fixed
        @click-left="$router.go(-1)"
      />
      <scroll ref="scroll">
        <div class="wrap onPxBottom mT20 lH80 alignCenter">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey">开票时间</span></van-col>
            <van-col span="12"><div class="alignLeft">{{detail.invoiceDate}}</div></van-col>
            <van-col span="5"><div><a :href="detail.invoicePdf" style="color: black">下载发票</a></div></van-col>
            <van-col span="1"><i class="fa fa-angle-right" aria-hidden="true"></i>  </van-col>
          </van-row>
        </div>
        <div :class="['wrap','onPxBottom','alignCenter','lH60']" v-if="detail.invoiceType!='02'">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey">开票信息</span></van-col>
            <van-col span="18">
              <div class="alignLeft">
                {{detail.invoiceType === '01'?'订单':'票号'}} {{detail.orid}}<br>{{detail.ticketname}}
              </div>
              <div class="alignLeft">
                {{detail.vtypeTitle}} {{detail.orderNo}} <br>
                <span v-if="detail.vtype == '03' && detail.typeRadio!=0">
                  {{`${detail.ticketName}`}} &nbsp;&nbsp;<span style="color: red">{{`x${detail.tcount}`}}</span>
                </span>
                <span v-else>
                  <span v-for="(item,index) in list" :key="index">
                    {{`${item.ticketName}`}} &nbsp;&nbsp;<span style="color: red">{{`x${item.ticketCount}`}}</span>
                    <br>
                  </span>
                </span>
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="wrapTitle">发票详情</div>
        <div class="wrap onPxBottom lH80 alignCenter">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey lH80">抬头类型</span></van-col>
            <van-col span="18"><div class="alignLeft">{{detail.invoiceCategory === 1 ?'个人':'企业'}}</div></van-col>
          </van-row>
        </div>
        <div class="wrap onPxBottom lH80 alignCenter">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey">发票抬头</span></van-col>
            <van-col span="18"><div class="alignLeft">{{detail.buyerName}}</div></van-col>
          </van-row>
        </div>
        <div class="wrap onPxBottom lH80 alignCenter" v-if="detail.invoiceCategory ===2">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey">税号</span></van-col>
            <van-col span="18"><div class="alignLeft">{{detail.buyerTaxpayerNum}}</div></van-col>
          </van-row>
        </div>

      <div class="wrap onPxBottom lH80 alignCenter">
        <van-row type="flex">
          <van-col span="6"><span class="colorGrey">手机号</span></van-col>
          <van-col span="18"><div class="alignLeft">{{detail.buyerTel}}</div></van-col>
        </van-row>
      </div>

        <div class="wrap onPxBottom lH80 alignCenter">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey">发票内容</span></van-col>
            <van-col span="18"><div class="alignLeft" style="color: #0088cc">{{detail.invoiceProject}}</div></van-col>
          </van-row>
        </div>
        <div class="wrap onPxBottom lH80 alignCenter">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey">发票金额</span></van-col>
            <van-col span="18"><div class="alignLeft" style="color: red">￥{{detail.invoiceMoney}}元</div></van-col>
          </van-row>
        </div>
        <div class="wrapTitle">接收方式</div>
        <div class="wrap onPxBottom lH80 alignCenter">
          <van-row type="flex">
            <van-col span="6"><span class="colorGrey">邮箱地址</span></van-col>
            <van-col span="18"><div class="alignLeft">{{detail.buyerEmail?detail.buyerEmail:'无'}}</div></van-col>
          </van-row>
        </div>
      </scroll>
    <!--<transition name="fade">-->
      <!--<div class="modelWrap" v-show="showImg" @click.prevent.self="showImg = false">-->
        <!--<img :src="detail.xzaddr">-->
      <!--</div>-->
    <!--</transition>-->
    </div>
  </div>
</template>
<script>
export default {
  name: 'InvoiceDetail',
  created () {
    this.getInit()
  },
  data () {
    return {
      scroll: '',
      showImg: false,
      title: this.$route.meta.title,
      detail: {
        savetype: '',
        invoiceCategory: '',
        invoiceDate: '',
        buyerTel: '',
        invoiceMoney: '',
        buyerTaxpayerNum: '',
        buyerEmail: '',
        orderNo: '',
        invoiceType: '',
        invoiceProject: '',
        invoicePdf: '',
        tcount: '',
        vtypeTitle: '票号',
        typeRadio: 0
      },
      list: []
    }
  },
  methods: {
    async getInit () {
      const parmas = {
        ioId: this.$route.params.id
      }
      const data = await this.$http.invoiceDetail(parmas)
           this.detail = data.data[0]

      if (this.detail.invoiceType === '02') {
        if (this.detail.orid.indexOf('***') !== -1) {
          this.detail.typeRadio = 0
          this.detail.vtypeTitle = '身份证'
        } else {
          this.detail.typeRadio = 3
          this.detail.vtypeTitle = '票号'
        }
      } else {
        this.detail.typeRadio = 2
        this.detail.vtypeTitle = '订单号'
      }

      const list = data.data.splice(1)
      this.list = [...list]
      this.$refs.scroll.scroll.refresh()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/page/InvoiceDetail.vue